import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const ApiPageHeader = styled.h1`
    ${Fonts.Heading.H300};
    margin: 0 ${Spacing.MD}px 0 0;
    line-height: 30px;
    color: ${Colors.Black.V150};
`;

export const detailsHeaderContainer = css`
    width: 100%;
`;

export const stringsContainer = css`
    width: 100%;
    padding-bottom: ${Spacing.MD}px;
`;

export const approvalBadge = css`
    align-self: center;

    height: fit-content;
    padding: ${Spacing["1XS"]}px ${Spacing.SM}px;

    background: ${Colors.Gray.V150};
    border: none;
    border-radius: ${Spacing["2XS"]}px;
`;

export const versionBadge = css`
    align-self: center;

    height: fit-content;
    margin-left: ${Spacing.XS}px;
    padding: ${Spacing["1XS"]}px ${Spacing.SM}px;

    background: ${Colors.Gray.V150};
    border: none;
    border-radius: ${Spacing["2XS"]}px;
`;

export const GreenDot = styled.div`
    display: inline-block;
    align-self: center;

    width: 7.5px;
    height: 7.5px;
    margin-right: ${Spacing["1XS"]}px;

    background-color: ${Colors.Green.V150};
    border-radius: 50%;
`;

export const OrangeDot = styled.div`
    display: inline-block;
    align-self: center;

    width: 7.5px;
    height: 7.5px;
    margin-right: ${Spacing["1XS"]}px;

    background-color: ${Colors.Orange.V100};
    border-radius: 50%;
`;
